import React from 'react';
import { Link } from 'react-router-dom';

interface NavButtonProps {
  children: React.ReactNode;
  active?: boolean;
  to: string;
}

export function NavButton({ children, active = false, to }: NavButtonProps) {
  return (
    <Link 
      to={to}
      className={`
        px-6 py-3 rounded-full text-sm font-medium
        ${active 
          ? 'bg-white text-blue-600 shadow-lg' 
          : 'bg-white/20 text-white hover:bg-white/30'
        } 
        transition-all duration-200
      `}
    >
      {children}
    </Link>
  );
} 